import React from 'react';
import PropTypes from 'prop-types';
import ArticleListItem from './ArticleListItem';
import styles from './ArticleList.module.scss';

const ArticleList = ({ contentItems }) => {
  return (
    <div className={styles['static-content-grid']}>
      {contentItems.map((item) => (
        <ArticleListItem
          key={item.key}
          imgSrc={item.imgSrc}
          articleTitle={item.articleTitle}
          articleUrl={item.articleUrl}
        />
      ))}
    </div>
  );
};

ArticleList.propTypes = {
  contentItems: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      imgSrc: PropTypes.string.isRequired,
      articleTitle: PropTypes.string.isRequired,
      articleUrl: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default ArticleList;
